var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageArticleList',{attrs:{"header-configuration":_vm.headerConfiguration,"init-articles":_vm.articles,"init-page":_vm.page,"init-per-page":_vm.perPage,"total":_vm.total}})
}
var staticRenderFns = []

export { render, staticRenderFns }